<template>
  <div class="submit-offer-description-window">
    <div class="submit-offer-description-window__header">
      <div class="submit-offer-description-window__header-text">
        {{ $t('Submitting offer') }}
      </div>
      <div class="submit-offer-description-window__header-title">
        {{ $t('Additions to your offer') }}
      </div>
    </div>
    <div class="submit-offer-description-window__body">
      <FormTextArea
        id="confirm-offer-description"
        :value="description"
        :label-text="$t('Description')"
        :placeholder="$t('Write short description for your offer')"
        @input="descriptionSetter"
      />
      <InfoBlock
        :text="
          $t(
            `After you submit an offer, the general contractor will see it. 
            He’ll write you in the chat or contact you by email or phone number.
            You can create multiple offers if you need to.`
          )
        "
      />
    </div>
    <div class="submit-offer-description-window__footer spacex-8">
      <Button size="large" color="neutral" type="filled" @click="closeModal">
        {{ $t('Cancel') }}
      </Button>
      <Button size="large" @click="context.emitter(description)">
        {{ $t('Submit offer') }}
      </Button>
    </div>
  </div>
</template>

<script>
  import Button from '@/components/ui/Button';
  import FormTextArea from '@/components/ui/FormTextArea';
  import { mapActions } from 'vuex';
  import InfoBlock from '@/components/ui/InfoBlock';

  export default {
    name: 'SubmitOfferDescriptionWindow',
    components: {
      InfoBlock,
      Button,
      FormTextArea,
    },
    props: {
      context: {
        type: Object,
        default: () => ({
          emitter: Function,
        }),
      },
    },
    data() {
      return {
        description: '',
      };
    },
    methods: {
      ...mapActions({
        closeModal: 'modal/closeModal',
      }),
      descriptionSetter(value) {
        this.description = value;
      },
    },
  };
</script>

<style scoped lang="scss">
  @import 'src/styles/colors';

  .submit-offer-description-window {
    background-color: white;
    border-radius: 12px;
    width: 687px;

    &__header {
      padding: 12px 20px;
      &-text {
        color: $grey500;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
      }
      &-title {
        font-weight: bold;
        font-size: 20px;
        color: $grey900;
        line-height: 28px;
      }
    }

    &__body {
      padding: 21px 20px;
      border-top: 1px solid $grey100;
      border-bottom: 1px solid $grey100;
    }

    &__footer {
      padding: 8px 20px;
      display: flex;
      justify-content: flex-end;
    }
  }
</style>
